<template>
    <div>

        <v-row class="d-flex justify-space-between py-0">


            <v-col>
                <v-chip class="primary" >
                    <h2>TEMA: <span class="tu-clase">{{dataSet.nombre_clase}}</span></h2>
                </v-chip>
            </v-col>

            <v-col cols="auto" class="py-0">
                <v-btn class="btn_block_style2 mr-2" dark  @click="visorDiapositivas(dataSet)">Visualizar</v-btn>
                <v-btn class="btn_block_style2 mr-2" dark  @click="crearDiapositiva()">Crear Diapositivas</v-btn>
                <v-btn class="btn_style3" dark  @click="atras">VOLVER</v-btn>
            </v-col>
        </v-row>
        
        <v-card >
            <v-alert type="warning" class="ml-2 mr-2" v-if="miscontenidos.length<1">
                <strong>Aún no tiene diapositivas creadas en este tema.</strong>
            </v-alert>
            <v-data-table :headers="headers" :items="miscontenidos" class="elevation-1 black--text" fixed-header>

                <template v-slot:[`item.titulo`]="{ item }">
                    <span v-html="item.titulo.replace(/(<([^>]+)>)/gi, '')"></span>
                </template>

                <template v-slot:[`item.tipo`]="{ item }">
                    <span v-if="item.tipo==='C1'">1 COLUMNA</span>
                    <span v-if="item.tipo==='C2'">2 COLUMNA</span>
                    <span v-if="item.tipo==='C3'">3 COLUMNA</span>
                    <span v-if="item.tipo==='PU'">PREGUNTA UNICA</span>
                    <span v-if="item.tipo==='PM'">PREGUNTA MULTIPLE</span>
                    <span v-if="item.tipo==='PV'">PREGUNTA VERDADERO O FALSO</span>
                </template>


                <template v-slot:[`item.dificultad`]="{ item }">
                    <v-chip small v-if="(item.dificultad===0 && item.tipo==='C1') || (item.dificultad===0 && item.tipo==='C2') || (item.dificultad===0 && item.tipo==='C3')">Sin dificultad</v-chip>
                    <v-chip small v-if="(item.dificultad===0 && item.tipo==='PU') || (item.dificultad===0 && item.tipo==='PM') || (item.dificultad===0 && item.tipo==='PV')" class="primary">BAJA</v-chip>
                    <v-chip small v-if="item.dificultad===1" class="warning">MEDIA</v-chip>
                    <v-chip small v-if="item.dificultad===2" class="error">ALTA</v-chip>
                </template>
                        
                <template v-slot:[`item.fecha`]="{ item }">
                    {{item.fec_us_ing | fecha}}
                </template>


                <template v-slot:[`item.edit`] ="{ item }">
                    <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="btn_editar px-0 mx-0" fab x-small @click="editContent(item)" v-if="item.tipo==='C1' || item.tipo==='C2' || item.tipo==='C3'">
                                <v-icon>fa-pencil-alt</v-icon>
                            </v-btn>

                            <v-btn v-on="on" class="btn_editar px-0 mx-0" fab x-small v-else @click="editarPregunta(item)">
                                <v-icon>fa-pencil-alt</v-icon>
                            </v-btn> 
                        </template>
                        <span>EDITAR</span>
                    </v-tooltip>
                </template>
        
                <template v-slot:[`item.delete`] ="{ item }">
                    <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="btn_eliminar px-0 mx-0" fab x-small @click="showConfirmDeleteDiapositiva(item)">
                                <v-icon>fa-trash-alt</v-icon>
                            </v-btn>
                        </template>
                        <span>BORRAR</span>
                    </v-tooltip>
                </template>
            </v-data-table>
        </v-card>       
        <!----------->
        <!-- eliminar diaposiitva -->
        <Confirm
            title="¿Estás seguro que desea eliminar esta diapositiva?"
            :active="confirmDeleteDiapositiva"
            @aceptar="deleteDiapositiva"
            @cancelar="closeConfirmDeleteDiapositiva"            
        />
        <!-- Visor Nuevo del Gestor de Contenido 
            Actualizado por el Ing Wuilmer 2020-01-22
        -->
        <component :is="compName" :estadoModal="estadoModalConfig" @close="estadoModalConfig = false"
                   :parametros="parametroConfigVisor">
        </component>

    </div>
</template>



<script>
    import axios from "../../../../helpers/axios";
    import visorContenido from './visorGestorContenido';
    import Confirm from '../../../../components/confirm'

    export default {
        name:'listaDiapositivas',
        props:['dataSet','miscontenidos'],
        
        components:{
                visorContenido,
                Confirm
        },
        
        data(){
            return{
              
                compName:"",
                estadoModalConfig: false,
                parametroConfigVisor : [],

                confirmDeleteDiapositiva:false,
                diapositivaDelete:'',


                headers: [
                    /* { text: 'TEMA', value: 'nombre_tema', class:'secondary black--text' }, */
                    { text: 'TITULO', value: 'titulo', class:'secondary black--text'},
                    { text: 'TIPO DE DIAPOSITIVA', value: 'tipo', class:'secondary black--text' },
                    { text: 'DIFICULTAD', value: 'dificultad', class:'secondary black--text' },
                    { text: 'ORDEN', value: 'orden', class:'secondary black--text' },
                    { text: 'FECHA DE CREACIÓN', value: 'fecha', class:'secondary black--text' },                    
                    {text: 'EDITAR', value: 'edit', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'100'},
                    {text: 'BORRAR', value: 'delete', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'1'}
                    

                ],
            }
        },
        
        filters: {
            fecha: function(string) {
                var cadena1 = string.slice(0, -14)
                var cadena2 = cadena1.replace(/^(\d{4})-(\d{2})-(\d{2})$/g,'$3/$2/$1');
                return cadena2;
            }
        },

        methods:{
            atras(){
                this.$emit('iraLista');
            },
            crearDiapositiva(){
                this.$emit('aggDiapositiva');
            },
            editContent(item){
                this.$emit('editar-contenido',item);
            },
            editarPregunta(item){
                this.$emit('editar-pregunta',item);
            },
            updateList(id) {
                this.$emit("actualizar-items",id);
            },
            mensaje(tipo,message){
                this.$emit('mostrar-mensaje',tipo,message);
            },
            /*******eliminar diapositiva jose guardia 17/07/2020 */
            showConfirmDeleteDiapositiva(item){
                this.confirmDeleteDiapositiva = true
                this.diapositivaDelete = item.id
            },
            closeConfirmDeleteDiapositiva(){
                this.confirmDeleteDiapositiva = false
                this.diapositivaDelete = ''
            },
            async  deleteDiapositiva(){
            try{

                const resp = await axios.put('/manager/contenido/detd/inac/'+this.diapositivaDelete);
                this.updateList(this.dataSet.id_clase);
                //console.log(resp.data);
                this.mensaje(resp.data.messageT,resp.data.message);
                this.closeConfirmDeleteDiapositiva()
                }catch(error){
                this.mensaje("E","Ha ocurrido un error , por favor intente nuevamente");
                }
            },

            // open Visor
            visorDiapositivas(item){
                            
                // const datosMiniatura = Object.assign(item, {evento:"agregar", miniatura:true, id_diapositiva:1});
                this.compName             = "visorContenido"
                this.estadoModalConfig    = true
                this.parametroConfigVisor = item
            
            },
        }
    }
</script>